import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { ClientsService } from '../clients.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { UserRoleService } from 'src/app/services/user-role.service';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { ConfirmationModalComponent } from 'src/app/modules/shared/modal/confirmation-modal/confirmation-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import {ConfirmationService} from 'primeng/api';
import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { CompanyService } from 'src/app/services/company.service';
import moment from 'moment';

@Component({
  selector: 'app-summary-info',
  templateUrl: './summary-info.component.html',
  styleUrls: ['./summary-info.component.scss']
})
export class SummaryInfoComponent implements OnInit {

  @Output() notify: EventEmitter<number> = new EventEmitter<number>();
  @Input() companyId;
  petitionerRoleList:[];
  summaryDisplayForm:FormGroup;
  listRoles: object[];
  listPermissions: object[];
  roleDataSource = [];
  uniqueListRoles = [];
  origColumns = [];
  displayedColumns: string[] = [];
  observableSubscription$ = new Subject();
  dirtyFlag: boolean = false;
  disableFields = false;
  getComanyData: any;
  getBusinessTpe: any;
  incorporationLocationData: any;
  noOfEmployeesData: any;
  naicsCodeData: any;
  feiNumberData: any;
  establishmentDateData: any;
  listOfUserData: any;
  listOfCreatedBeneficiariesData: any;
  listOfInvitedBeneficiariesData: any;
  roleDTOData: any;

  constructor(private clientsService: ClientsService,
              private userRoleService: UserRoleService,
              private companyService: CompanyService,
              protected store: Store<any>,
              public dialog: MatDialog,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private toastr: ToastrService,
              private confirmationService: ConfirmationService,
              private fb: FormBuilder) {
      this.listRoles = [];
     }

  ngOnInit() {
    // this.companyId = 425;
    this.summaryDisplayForm = this.fb.group({
      companyName: [''],
      businessType: [''],
      incorporationLocation: [''],
      establishmentDate: [''],
      noOfEmployees: [''],
      naicsCode: [''],
      feiNumber: [''],
      petitionerRoleList: [''],
      usersList: [''],
      listOfCreatedBeneficiaries: [''],
      listOfInvitedBeneficiaries : ['']
    });
    this.getReviewSummaryDetails();
    // this.userRoleService.getRoleByCompanyId(parseInt(sessionStorage.getItem('companyId'))).subscribe(data => {
    //   if (data) {
    this.userRoleService.getPermissions().subscribe(data => {
          this.listPermissions = data;
          // console.log(data);
          this.getReviewSummaryDetails();
        });
    //   }
    // });

    this.activatedRoute.params
    .subscribe(parameter => {
      let parameterId = null;
      if (parameter.hasOwnProperty('id')) {
        //this.companyId = parameterId;
        this.companyService.getCompaniesById(parameter.id).subscribe(data => {
          if(data.status.code == 'ACTV')
            this.disableFields = true;
        });
      } else {

      }
    });

  }

  getReviewSummaryDetails(){
    this.clientsService.getReviewSummary(this.companyId).subscribe(data => {
      if(data){
        // console.log('dataaaa:-' , JSON.stringify(data));
        this.getComanyData = data.companyName;
        this.getBusinessTpe = data.businessType;

        this.incorporationLocationData = data.incorporationLocation;
        this.establishmentDateData = moment(data.establishmentDate).utc().format('YYYY-MM-DD') ;
        this.noOfEmployeesData = data.noOfEmployees;
        this.naicsCodeData = data.naicsCode;
        this.feiNumberData = data.feiNumber;

        this.listOfUserData = data.listOfUsers;
        this.roleDTOData = data.roleDTO.permissionList;
        this.listOfCreatedBeneficiariesData = data.listOfCreatedBeneficiaries;
        this.listOfInvitedBeneficiariesData = data.listOfInvitedBeneficiaries;

        this.uniqueListRoles = [];
        this.origColumns = [];
        //this.listPermissions = data.roleDTO['permissionList'];
        this.listRoles = data.roleDTO;

        data.roleDTO.forEach((uniqueRoles) => {
          if (!this.uniqueListRoles.find(x => x.name === uniqueRoles.name)) {
            this.uniqueListRoles.push(uniqueRoles);
          }
        });

        this.uniqueListRoles.forEach((element: any) => {
          if (element.name !== "" && element.name !== null) {
            this.origColumns.push({
              columnDef: element.name,
              header: element.name.toUpperCase(),
              columnType: 'check',
              customClass: ''
            });
          }
        });
        this.displayedColumns = this.origColumns.map(c => c.columnDef);
        this.summaryDisplayForm.patchValue({
          companyName: data.companyName,
          businessType: data.businessType,
          incorporationLocation: data.incorporationLocation,
          establishmentDate: moment(data.establishedDate).format('MM-DD-YYYY'),
          noOfEmployees: data.noOfEmployees,
          naicsCode: data.naicsCode,
          feiNumber: data.feiNumber,
          petitionerRoleList: this.buildRoleList(this.listPermissions),
          usersList: data.listOfUsers,
          listOfCreatedBeneficiaries: data.listOfCreatedBeneficiaries,
          listOfInvitedBeneficiaries:data.listOfInvitedBeneficiaries
        });
      }
      //this.businessTypeList = data;
    });

  }

  buildRoleList(permissions){
    permissions.forEach((v, k) => {
      let rowObj = {
        perm_name: v['description']
      }
      this.listRoles.forEach((val, key) => {
        rowObj[val['name']] = false;
        if (val['permissionList'].length > 0) {
          val['permissionList'].forEach(item => {
            if (item.id == v['id']) {
              rowObj[val['name']] = true;
            }
          })
        } else {
          rowObj[val['name']] = false;
        }
      });
      this.roleDataSource.push(rowObj);
    });
    return(this.roleDataSource);
  }

  onCancel(){
    if (this.dirtyFlag) {

      this.dialog.open(ConfirmationModalComponent, {
        width: '400px',
        data: {
          update: {
            title: 'Unsaved Changes!',
            message: 'Changes you made on this section is not saved yet. Do you wish to continue?'
          },
          // buttons: ['No, Stay on the Page', 'Yes, Leave the Page']
          buttons: ['No', 'Yes'],
          disableClose: true
        }
      }).afterClosed().subscribe(confirmed => {
        if (confirmed) {
          this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
          this.dirtyFlag = false;
          this.router.navigate([`/attorney-landing/clients`]);
        }
      });

    } else {
      this.router.navigate([`/attorney-landing/clients`]);
    }

  }


  onPrevious(){
    if (this.dirtyFlag) {

      this.dialog.open(ConfirmationModalComponent, {
        width: '400px',
        data: {
          update: {
            title: 'Unsaved Changes!',
            message: 'Changes you made on this section is not saved yet. Do you wish to continue?'
          },
          // buttons: ['No, Stay on the Page', 'Yes, Leave the Page']
          buttons: ['No', 'Yes'],
          disableClose: true
        }
      }).afterClosed().subscribe(confirmed => {
        if (confirmed) {
          this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
          this.dirtyFlag = false;
          this.notify.emit(4);
        }
      });

    } else {
      this.notify.emit(4);
    }

  }

  onSubmit(){
    const payload = {
      companyId: this.companyId,
    };
    this.clientsService.postReviewSummary(this.companyId, payload)
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: any) => {
        if (response.status == 200) {
          this.toastr.success(response.message, 'Success');
          this.router.navigate([`/attorney-landing/clients`]);
        }
      });
  }

  editSection(tabId){
    this.notify.emit(tabId);
  }

}
